import { Field } from "formik";

export default function BookingTextArea({ errors, ...props }) {
    return (
        <>
            <Field {...props} className="px-6 py-4 block w-full sm:text-sm !outline-none resize-none bg-light_background h-full" />
        </>
    );
}
